import React from 'react'
import HeaderPage from '../../components/headerpage/HeaderPage'
import { MdZoomOutMap } from "react-icons/md"
import useAppContext from '../../hook/useAppContext'
import Empty from '../../components/empty/Empty'
import './images.css'

const Images = ({current}) => {

      const {user, setImgObj, setModal} = useAppContext()
      const {images} = user 

      if(current !== "images") return 

      if(images.code){
            return (
                  <Empty title={"Photos"} desc={"Oops, it seems that no image has been submitted to the gallery yet."}/>
            )
      }

      const setOpenModal = (obj) => {
            setImgObj(obj)
            setModal(true)
      }

      return (
            <div className="page_group">
                  <HeaderPage desc={`Photos`}/>
                  <div className="page_group__images">
                        <ul className="group_images__list flex">
                              {
                                    images.map((item, index) => (
                                          <li className="image_list__item" key={index}>
                                                <div className="image_item__cover">
                                                      <div className="image_item__cover_img flex">
                                                            <img src={item.url} alt={item.title} />
                                                      </div>
                                                      <button className="btn_image__zoom" onClick={() => setOpenModal(item)}><MdZoomOutMap /></button>
                                                </div>
                                                <div className="image_item__description">
                                                      <p>{item.title}</p>
                                                </div>
                                          </li>
                                    ))
                              }
                              
                        </ul>
                  </div>
            </div>
      )
}

export default Images
